/* istanbul ignore file */

import { connect } from 'react-redux';

import {
  selectOptionsBreakdown,
  selectSelectedOptionsTotal,
  selectTotalPrice,
} from 'src/redux/basket/selectors';
import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { selectProduct, selectProductPrice } from 'src/redux/product/selectors';
import type { PriceBreakdownStateProps } from './PriceBreakdown';
import { PriceBreakdown } from './PriceBreakdown';

export const mapStateToProps = (state: ReduxApplicationState): PriceBreakdownStateProps => {
  const product = selectProduct(state);

  return {
    personalisable: product.specialFeatures.personalisable,
    productPrice: selectProductPrice(state),
    totalPrice: selectTotalPrice(state),
    optionsTotal: selectSelectedOptionsTotal(state),
    priceBreakdown: selectOptionsBreakdown(state),
  };
};

export const PriceBreakdownContainer = connect(mapStateToProps)(PriceBreakdown);
